"use client";

/**
 * PluginBootstrap — mounts once at root layout.
 *
 * Phase 25-AB Task 15: triggers the SDK bootstrap on first client render.
 * No DOM output. Registry is idempotent so repeat mounts during dev HMR
 * are harmless.
 */

import { useEffect } from "react";
import { bootstrapPlugins } from "@/plugin-sdk/bootstrap";

export function PluginBootstrap() {
	useEffect(() => {
		bootstrapPlugins().catch((err) => {
			console.error("[plugin-sdk] bootstrap failed", err);
		});
	}, []);
	return null;
}
